module.exports = __webpack_public_path__ + "img/BE0464657318.e9398489.png";